<router-outlet />
<div class="container-xxl py-5">
  <div class="container">
    <!-- Stages Brief Start -->
    <div id="STAGES_SECTION" class="row g-5 align-items-center">
      <div class="col-lg-11 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-4"> {{ ACADEMIC_DATA.stages.title[language] }}</h1>
        <p>
          {{ ACADEMIC_DATA.stages.description[language] }}
        </p>
      </div>
      <div class="row g-4">
        <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
          <a href="/academics/stages/kg">
            <div class="facility-item">
              <div class="facility-text bg-primary">
                <h3 class="text-primary mb-3">{{ "kg" | translate }}</h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </div>
          </a>
        </div>

        <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
          <a href="/academics/stages/primary">
            <div class="facility-item">
              <div class="facility-text bg-success">
                <h3 class="text-success mb-3">{{ "primary" | translate }}</h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </div>
          </a>
        </div>

        <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
          <a href="/academics/stages/preparatory">
            <div class="facility-item">
              <div class="facility-text bg-warning">
                <h3 class="text-warning mb-3">
                  {{ "preparatory" | translate }}
                </h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </div>
          </a>
        </div>

        <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
          <a href="/academics/stages/secondary">
            <div class="facility-item">
              <div class="facility-text bg-info">
                <h3 class="text-info mb-3">{{ "secondary" | translate }}</h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- Stages Brief End -->
    <br />
    <br />
    <br />
    <!-- Library Brief Start -->
    <div id="LIBRARY_SECTION" class="row g-5 align-items-center">
      <h1 class="mb-4">{{ ACADEMIC_DATA.library.brief.title[language] }}</h1>
      <div class="bg-light rounded">
        <div class="row g-0">
          <div
            class="col-lg-6 wow fadeIn"
            data-wow-delay="0.1s"
            style="min-height: 400px"
          >
            <div class="position-relative h-100">
              <img
                class="position-absolute w-100 h-100 rounded"
                src="../../../assets/img/{{ ACADEMIC_DATA.library.brief.image }}"
                style="object-fit: cover"
              />
            </div>
          </div>
          <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            <div class="h-100 d-flex flex-column justify-content-center p-5">
              <p class="mb-4">
                {{ ACADEMIC_DATA.library.brief.description[language] }}
              </p>
              <a
                class="btn btn-primary py-3 px-5"
                href="/academics/libraries/frLibrary"
                >{{ "go_to_fr_library" | translate }}</a
              >
              <br />
              <a
                class="btn btn-primary py-3 px-5"
                href="/academics/libraries/arLibrary"
                >{{ "go_to_ar_library" | translate }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Library Brief End -->
    <br />
    <br />
    <br />
    <!-- Alumni Brief Start -->
    <div id="ALUMNI_SECTION" class="row g-5 align-items-center">
      <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-4">
          {{ ALUMNI_DATA.title[language] }}
        </h1>
        <p>
          {{ ALUMNI_DATA.description[language] }}
        </p>
        <div class="row g-4 align-items-center">
          <div class="col-sm-6">
            <a
              class="btn btn-primary rounded-pill py-3 px-5"
              href="/academics/alumni"
              >{{ "go_to_alumni" | translate }}</a
            >
          </div>
        </div>
      </div>
      <div class="col-lg-6 about-img wow fadeInUp" data-wow-delay="0.5s">
        <div class="row">
          <div class="col-12 text-center">
            <img
              class="img-fluid w-75 rounded-circle bg-light p-3"
              src="../../../assets/img/{{ ALUMNI_DATA.image}}"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Alumni Brief End -->
  </div>
</div>
